// Components/SalesPerDay15NewGraph.jsx
import React from "react";
import { Box, Typography } from "@mui/material";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Filler
);

export default function SalesPerDay15NewGraph({ data }) {
  const chartData = {
    labels: data.map((d) => d.day),
    datasets: [
      {
        label: "Total Facturado por Día",
        data: data.map((d) => d.daily_total),
        borderColor: "#2d8bba",
        backgroundColor: "#41b8d580",
        fill: true,
        tension: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (context) {
            const index = context.dataIndex;
            const total = data[index]?.daily_total ?? 0;
            const count = data[index]?.sales_count ?? 0;
            return [
              `Total facturado: $${total}`,
              `Cantidad de ventas: ${count}`,
            ];
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
      x: {
        ticks: {
          autoSkip: false,       // No omitir etiquetas
          maxRotation: 0,        // No rotar
          minRotation: 0,        // Fuerza horizontal
          font: {
            size: 12
          }
        },
        title: {
          display: true,
          text: "Día del mes"
        }
      }
    },
  };

  return (
    <Box>
      <Typography variant="h6" mb={1}>
        Facturación quincena actual
      </Typography>
      <Line data={chartData} options={options} />
    </Box>
  );
}
